import angular from 'angular';
import { SharedModule } from '../shared/shared.module';
import { SupportComponent } from './support.component';

/**
 * A module for landing pages and site support.
 */
export const HomeModule = angular
    .module("apex.mainApp.home", [
        SharedModule
    ])
    .component("apexSupport", SupportComponent)
    .name;
